'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSellerCardDatas = exports.getSellerCardData = exports.getLiveItemCardData = exports.getLiveItemCardDatas = exports.getItemCardDatas = exports.getItemCardData = exports.getPreviewCatalogCardsData = exports.getLiveCatalogCardDatas = exports.getLiveCatalogCardData = exports.getCatalogCardDatas = exports.getCatalogCardData = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _reselect = require('reselect');

var _biddingInfo = require('./biddingInfo');

var _buyNow = require('./buyNow');

var _catalog = require('./catalog');

var _console = require('./console');

var _catalogRegistration = require('./catalogRegistration');

var _coverLots = require('./coverLots');

var _item = require('./item');

var _saveItem = require('./saveItem');

var _savedItemCount = require('./savedItemCount');

var _savedSearchItem = require('./savedSearchItem');

var _seller = require('./seller');

var _sellerCatalogCounts = require('./sellerCatalogCounts');

var _sellerPreviewCatalogs = require('./sellerPreviewCatalogs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalStateSelector = function globalStateSelector(state) {
    return state;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var getCatalogCardData = exports.getCatalogCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogId) {
    var catalog = (0, _catalog.getCatalog)(state, catalogId);
    var coverLots = (0, _coverLots.getCoverLots)(state, catalogId);
    var seller = (0, _seller.getSeller)(state, catalog.sellerId);
    return { catalog: catalog, coverLots: coverLots, seller: seller };
});

var getCatalogCardDatas = exports.getCatalogCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogIds) {
    return catalogIds.map(function (id) {
        return getCatalogCardData(state, id);
    });
});

var getLiveCatalogCardData = exports.getLiveCatalogCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogId) {
    return (0, _extends3.default)({}, getCatalogCardData(state, catalogId), {
        bidders: (0, _console.getCatalogBidders)(state, catalogId)
    });
});

var getLiveCatalogCardDatas = exports.getLiveCatalogCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogIds) {
    return catalogIds.map(function (id) {
        return getLiveCatalogCardData(state, id);
    });
});

var getPreviewCatalogCardsData = exports.getPreviewCatalogCardsData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, sellerId) {
    var seller = (0, _seller.getSeller)(state, sellerId);
    return (0, _sellerPreviewCatalogs.getSellerPreviewCatalogs)(state, sellerId).map(function (catalogPreview) {
        return { catalogPreview: catalogPreview, seller: seller };
    });
});

var getItemCardData = exports.getItemCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemId) {
    var item = (0, _item.getItem)(state, itemId);
    var biddingInfo = (0, _biddingInfo.getBiddingInfo)(state, item.itemId);
    var buyNow = (0, _buyNow.getBuyNow)(state, item.itemId);
    var catalogId = item.catalogId,
        sellerId = item.sellerId;

    var catalog = (0, _catalog.getCatalog)(state, item.catalogId);
    var catalogRegistration = (0, _catalogRegistration.getCatalogRegistration)(state, catalogId);
    var savedItem = (0, _saveItem.getSavedItem)(state, itemId);
    var savedSearch = (0, _savedSearchItem.getSavedSearchItem)(state, itemId);
    var seller = (0, _seller.getSeller)(state, sellerId);
    var saves = (0, _savedItemCount.getSavedItemCount)(state, itemId);

    return {
        biddingInfo: biddingInfo,
        buyNow: buyNow,
        catalog: catalog,
        catalogRegistration: catalogRegistration,
        item: item,
        savedItem: savedItem,
        savedSearch: savedSearch,
        saves: saves,
        seller: seller
    };
});

var getItemCardDatas = exports.getItemCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemIds) {
    return itemIds.map(function (id) {
        return getItemCardData(state, id);
    });
});

var getLiveItemCardDatas = exports.getLiveItemCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemIds) {
    return itemIds.map(function (id) {
        return getLiveItemCardData(state, id);
    });
});

var getLiveItemCardData = exports.getLiveItemCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemId) {
    return (0, _extends3.default)({}, getItemCardData(state, itemId), {
        saves: (0, _savedItemCount.getSavedItemCount)(state, itemId)
    });
});

var getSellerCardData = exports.getSellerCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, sellerId) {
    var seller = (0, _seller.getSeller)(state, sellerId);
    var catalogCounts = (0, _sellerCatalogCounts.getSellerCatalogCounts)(state, sellerId);
    return { catalogCounts: catalogCounts, seller: seller };
});

var getSellerCardDatas = exports.getSellerCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, sellerIds) {
    return sellerIds.map(function (id) {
        return getSellerCardData(state, id);
    });
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/cardData.js
// module id = 6OFE
// module chunks = 60